export const transformValuesToBE = values => {
  return {
    permissions: Object.keys(values).filter(key => values[key])
  }
}
